import { API } from "../../../utils/Apis";
import { AppDispatch } from "../Store";
import {
  getPayoutHistoryList,
  loginUser,
  logoutUser,
  updateFavorites,
  updateNotiCount,
  updateStripeAccount,
  updateStripeBalance,
  updateUser,
} from "../Reducers/AuthReducers";
import { getLocalData, saveLocalData } from "../../../utils/LocalStorage";
import { toggleMenu, toogleThemeMode } from "../Reducers/ThemeReducers";
import { MENU_STATE_TEXT, THEME_STATE_TEXT } from "../../../Constants";

export const toogleThemeAction = (theme: string, dispatch: AppDispatch) => {
  saveLocalData(THEME_STATE_TEXT, theme);

  dispatch(toogleThemeMode({ mode: theme }));
};

export const toogleSideMenuAction = (dispatch: AppDispatch) => {
  const sidebarMenu = getLocalData(MENU_STATE_TEXT);

  console.log("sidebarMenu :", sidebarMenu);

  const newState = sidebarMenu && sidebarMenu === "false" ? true : false;
  saveLocalData(MENU_STATE_TEXT, newState);

  dispatch(toggleMenu({ menuState: newState }));
};

export const socialLoginAction = (data: object, dispatch: AppDispatch) =>
  API.socialLogin(data).then((res) => {
    if (res.type === "success") {
      const accessToken = res.data.accessToken;
      const isLoggedIn = true;

      dispatch(loginUser({ user: res.data.user, accessToken, isLoggedIn }));
    }

    return res;
  });

export const loginAction = (data: object, dispatch: AppDispatch) =>
  API.login(data).then((res) => {
    if (res.type === "success") {
      const accessToken = res.data.accessToken;
      const isLoggedIn = true;

      dispatch(loginUser({ user: res.data.user, accessToken, isLoggedIn }));
    }

    return res;
  });

export const signupAction = (data: object) => API.signup(data);

export const getUserPofileAction = (dispatch: AppDispatch) =>
  API.getUserProfile().then((res) => {
    if (res.type === "success" && res.data) {
      console.log("ProfileRes :", res);

      const accessToken = res.accessToken;
      const isLoggedIn = true;
      const messageCount =
        res.data && res.data.unreadMessagesCount
          ? res.data.unreadMessagesCount
          : 0;
      const notificationCount =
        res.data && res.data.unreadNotificationsCount
          ? res.data.unreadNotificationsCount
          : 0;

      dispatch(updateNotiCount({ messageCount, notificationCount }));
      dispatch(loginUser({ user: res.data, accessToken, isLoggedIn }));
    }

    return res;
  });

export const verifyUserAction = (data: object, dispatch: AppDispatch) =>
  API.verifyUser(data).then((res) => {
    if (res.type === "success") {
      const accessToken = res.accessToken;
      const isLoggedIn = true;
      dispatch(loginUser({ user: res.data, accessToken, isLoggedIn }));
    }

    return res;
  });

export const logoutAction = (dispatch: AppDispatch) =>
  API.logout().then((res) => {
    if (res.type === "success") {
      dispatch(logoutUser());
    }
    return res;
  });

export const refrshAccessTokenAction = (dispatch: AppDispatch) =>
  API.refreshAuthToken().then((res) => {
    if (res.status === 401) {
      dispatch(logoutUser());
    }
    return res;
  });

export const updateUserAction = (data: object, dispatch: AppDispatch) =>
  API.updateProfile(data).then((res) => {
    if (res.type === "success" && res.data) {
      dispatch(updateUser({ user: res.data }));
    }

    return res;
  });

export const changePasswordAction = (data: object) =>
  API.changePassword(data);

// Stripe Payout Actions

export const getStripeAccountStatusAction = (dispatch: AppDispatch) =>
  API.getStripeAccountStatus().then((res) => {
    if (res.type === "success" && res.data) {
      dispatch(updateStripeAccount({ data: res.data }));
    }

    return res;
  });

export const connectStripeAccountAction = (
  data: object,
  dispatch: AppDispatch
) =>
  API.connectStripeAccount(data).then((res) => {
    if (res.type === "success" && res.data) {
      dispatch(updateStripeAccount({ data: res.data }));
    }

    return res;
  });

export const getUserBalanceAction = (dispatch: AppDispatch) =>
  API.getBalance().then((res) => {
    if (res.type === "success" && res.data) {
      dispatch(updateStripeBalance({ data: res.data }));
    }

    return res;
  });

export const executeWithdrawalAction = (data: object, dispatch: AppDispatch) =>
  API.executeWithdraw(data).then((res) => {
    if (res.type === "success" && res.data) {
      //dispatch(updateUser({ user: res.data }));
    }

    return res;
  });

export const retryWithdrawalAction = (data: object, dispatch: AppDispatch) =>
  API.retryWithdraw(data).then((res) => {
    if (res.type === "success" && res.data) {
      // dispatch(updateUser({ user: res.data }));
    }

    return res;
  });

export const payoutHistoryAction = (data: object, dispatch: AppDispatch) =>
  API.getPayoutHistory(data).then((res) => {
    if (res.type === "success" && res.data) {
      dispatch(getPayoutHistoryList({ items: res.data.payouts }));
    }

    return res;
  });
